import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';
import { UnleashClient } from 'unleash-proxy-client';

import unleashConfig from './unleashConfig';

const PREFIX = 'unleash:repository';

let unleash: UnleashClient;

let canCreateUnleashClient = true;

if (Platform.OS === 'web') {
  // nextjs requires the window typeof check to be in its own conditional block
  if (typeof window === 'undefined') {
    canCreateUnleashClient = false;
  }
}

if (!unleashConfig.url || !unleashConfig.clientKey) {
  canCreateUnleashClient = false;
}

if (canCreateUnleashClient) {
  unleash = new UnleashClient({
    ...unleashConfig,
    storageProvider: {
      save: (name: string, data: any) => {
        const repo = JSON.stringify(data);
        const key = `${PREFIX}:${name}`;

        return AsyncStorage.setItem(key, repo);
      },
      get: async (name: string) => {
        const key = `${PREFIX}:${name}`;
        const data = await AsyncStorage.getItem(key);

        return data ? JSON.parse(data) : undefined;
      },
    },
  });
} else {
  // Create a placeholder client for SSR environments
  // Since all callers should be client-side only, we can use an empty object
  unleash = {} as UnleashClient;
}

export default unleash;
